module.exports = __webpack_public_path__ + "img/21.c5b2c122.png";